import { render, staticRenderFns } from "./ShipmentDetails.vue?vue&type=template&id=f07cc37e&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"
import style0 from "./ShipmentDetails.vue?vue&type=style&index=0&id=f07cc37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07cc37e",
  null
  
)

export default component.exports